import React, { Component } from 'react';
import { object, func } from 'prop-types';
import JobPricingSummaryTab from './JobPricingSummaryTab/JobPricingSummaryTab';
import './JobPricingSummaryTabResults.scss';

class JobPricingSummaryTabResults extends Component {
  static propTypes = {
    summaryData: object,
    viewNotPricedJobs: func,
    viewPricedJobs: func
  };

  render() {
    const { summaryData, viewNotPricedJobs, viewPricedJobs } = this.props;
    const isPricedActive = summaryData.selectedTab === 'priced';

    return (
      <div className="results-summary">
        <JobPricingSummaryTab
          onClick={viewPricedJobs}
          tabTitle="Jobs priced"
          tabValue={summaryData.priced.length}
          active={isPricedActive}
          valueClassName="results-tab__1"
        />
        <JobPricingSummaryTab
          onClick={viewNotPricedJobs}
          tabTitle="Jobs cannot be priced"
          tabValue={summaryData.skipped.length}
          active={!isPricedActive}
          valueClassName="results-tab__2"
        />
      </div>
    );
  }
}

export default JobPricingSummaryTabResults;
